import { Link as ChakraLink, Stack, Text } from '@chakra-ui/react'
import truncate from 'lodash/truncate'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import ListLabels from '@app/pages/shared/listLabels'
import type { Strategy } from '@graphql/queries'

interface Props {
  data: Strategy
}

const StrategyName: FC<Props> = ({ data: strategy }) => {
  const { id, name, description, labels } = strategy

  return (
    <Stack>
      <ChakraLink
        asChild
        data-cy="map-name"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Link to={`/strategy/${id}/map`}>
          <Stack>
            <Text minW="xs" fontSize="md" whiteSpace="normal" wordBreak="break-all" title={name}>
              {truncate(name, { length: 100 })}
            </Text>
            <Text maxW="xl" fontSize="sm" color="gray.500" title={description}>
              {truncate(description, { length: 300 })}
            </Text>
          </Stack>
        </Link>
      </ChakraLink>
      <ListLabels labels={labels} />
    </Stack>
  )
}

export default StrategyName
